import api from "../api";
import backEnd from "../../constants/backEnd";

const postImagePackSuccess = async (sessionId) => {
    const response = await api.post(`${backEnd.url}webhooks/stripe/images/success/`, {
        session_id: sessionId,
    });
    
    return response.data;
};

export default postImagePackSuccess;
